import { get } from "lodash";

export const taxPayerData = (state) => get(state, "user.taxPayer", {});
export const contributorData = (state) => get(state, "user.contributor", {});
export const duplicateData = (state) => get(state, "user.duplicateData", false);
